import LOGO from 'const/logo'
import { SITE_URL } from 'config/appConfig'

import s from './Header.module.scss'

const Header = () => {
  return (
    <header className={s.header}>
      <div className={s.container}>
        <div className={s.logo}>
          <a
            className={s.logoLink}
            href={SITE_URL}
            target="_blank"
            rel="noreferrer"
            title="Go back to the main page"
          >
            <img src={LOGO.DESKTOP} alt="Logo CoinAvatar" />
          </a>
        </div>
      </div>
    </header>
  )
}

export default Header
